import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import ImDfm3dViewer from '@Admin/AdminQuotingPage/ModelViewerPanel/ImDfmModePanel/ImDfm3dViewer'

import {
    getMeasurementUnits,
    getSelectedPatchHashes,
    getSelectedPoints,
    getViewerInstance,
} from '~/redux-modules/qmr-viewer/selectors'
import { setToolVisibility } from '~/redux-modules/qmr-viewer/actions'

import qmrImDfmModal3dViewerQuery from './qmrImDfmModal3dViewerQuery'
import { qmrImDfmModal3dViewer as ImDfmModal3dViewerQueryType } from './__generated__/qmrImDfmModal3dViewer'

type ParamsType = {
    qmrId: string
}

interface ImDfmModal3dViewerPropsType {
    dfmFeedbackId: string | null
}

const ImDfmModal3dViewer = (props: ImDfmModal3dViewerPropsType) => {
    const { dfmFeedbackId } = props

    const dispatch = useDispatch()
    const { qmrId } = useParams<ParamsType>()

    const { data: threeDViewerData } = useQuery<ImDfmModal3dViewerQueryType>(
        qmrImDfmModal3dViewerQuery,
        {
            variables: {
                qmrId,
                showDeleted: true,
            },
            skip: !qmrId,
        },
    )

    const selectedPatchHashes = useSelector(getSelectedPatchHashes)
    const selectedPoints = useSelector(getSelectedPoints)
    const units = useSelector(getMeasurementUnits)
    const viewer = useSelector(getViewerInstance)

    useEffect(() => {
        if (viewer) {
            const measurementInfo = viewer.getMeasurement({
                patchHashes: selectedPatchHashes,
                points: selectedPoints,
                units,
            })

            if (measurementInfo) {
                dispatch(
                    setToolVisibility({
                        measurePanel: true,
                        interactionControlBox: false,
                    }),
                )
            } else {
                dispatch(
                    setToolVisibility({
                        measurePanel: false,
                        interactionControlBox: false,
                    }),
                )
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [viewer])

    const qmr = threeDViewerData?.quoteModelRevision
    const dfmFeedback = qmr?.dfmFeedback
    const holes = qmr?.holes
    const sceneBundle = qmr?.partRevision?.sceneBundle

    return (
        <ImDfm3dViewer
            dfmFeedback={dfmFeedback}
            holes={holes}
            isLocatedInModal
            sceneBundle={sceneBundle}
            selectedSlideDfmId={dfmFeedbackId}
        />
    )
}

export default ImDfmModal3dViewer
